import { browserName, osName } from "react-device-detect";

function getIsPWA() {
  if (typeof window === "undefined") return false;
  const m = window.matchMedia;
  if (!m) return false;
  return (
    m("(display-mode: standalone)").matches ||
    m("(display-mode: fullscreen)").matches ||
    m("(display-mode: minimal-ui)").matches ||
    !!navigator.standalone
  );
}

function getBrowserSource() {
  if (
    typeof osName === "string" &&
    typeof browserName === "string" &&
    osName?.length &&
    browserName?.length
  ) {
    return `${osName?.split(" ").join("_")}-${browserName
      ?.split(" ")
      .join("_")}-web`;
  }
  if (typeof osName === "string" && osName?.length) {
    return `${osName?.split(" ").join("_")}-UNKNOWN-web`;
  }
  if (typeof browserName === "string" && browserName?.length) {
    return `UNKNOWN-${browserName?.split(" ").join("_")}-web`;
  }
  return "UNKNOWN-web";
}

function computeCurrentSource() {
  return getIsPWA() ? "PWA" : getBrowserSource();
}

let CURRENT_SOURCE = computeCurrentSource();

// Re-check after a tick so PWA (display-mode: standalone) is detected once the app has fully loaded
if (typeof window !== "undefined") {
  const update = () => {
    if (getIsPWA()) CURRENT_SOURCE = "PWA";
  };
  if (typeof queueMicrotask !== "undefined") {
    queueMicrotask(update);
  }
  setTimeout(update, 0);
}

export { CURRENT_SOURCE };
